module.exports = "https://static.wanderu.com/ui-react/_next/static/media/favicon.ico";